import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

export function calculateWallLossPercent(
  minThickness: GeckoMeasurement | undefined,
  nominalThickness: GeckoMeasurement | undefined
): GeckoMeasurement | undefined {
  if (!minThickness || !nominalThickness) {
    return undefined
  }

  if (nominalThickness.num === 0) {
    return GeckoMeasurement.CreateFromValue(
      Number.NaN,
      GeckoMeasurementUnit.Percent
    )
  }

  const minThicknessConverted = minThickness.convertTo(nominalThickness.unit)
  const lossPercent =
    ((nominalThickness.num - minThicknessConverted.num) /
      nominalThickness.num) *
    100

  return GeckoMeasurement.CreateFromValue(
    Math.max(0, lossPercent),
    GeckoMeasurementUnit.Percent
  )
}
